import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { copyLibrary, deleteLibrary } from "redux/index";
import { ActionConfirmModal, DuplicateModal } from "shared/modals/index";
import { useModal } from "use-modal-hook";

export default function BaseActions({ library }) {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const history = useHistory();

	const [showCopyModal] = useModal(DuplicateModal);
	const [showModalDelete] = useModal(ActionConfirmModal);
	

	const handleDelete = () => {
		const callBack = () => {
			if (pathname === "/library-custom") history.push("/libraries");
		};
		showModalDelete({
			bodyContent: "DELETE_LIBRARY",
			Action: () => deleteLibrary({ libraryId: library?.id, onSuccess: callBack }),
			actionBtnText: "ASPX_13",
		});
	};
	const handlecopy = () => {
		showCopyModal({
			title: `${t("JS_61")} ${t("LIBRARY")}`,
			inputTitle: "NAME",
			closeBtnLabel: "COPY",
			inputValue: `[${t("COPY_NOUN").toUpperCase()}]- ` + library?.name,
			action: ({ name, selectedWorkspaces }) => copyLibrary({ libraryId: library?.id, name: name, workspaceIds: selectedWorkspaces.map((w) => w?.id) }),
		});
	};
	return [
		{
			id: "copy",
			handleClick: () => {
				handlecopy();
			},
			icon: "COPY",
			text: t("COPY"),
		},
		{
			id: "delete",
			handleClick: () => handleDelete(),
			icon: "DELETE",
			text: t("CS_45"),
		},
		
	];
}
